import React from 'react';
import './FactionElementalsDescription.css';
import {
  FACTION_ELEMENTALS_BUILDING_CENTRAL_QUARTER_DISCOUNT,
  FACTION_ELEMENTALS_CONSTRUCTION_ACTIONS_BONUS
} from "../../../../configs/factions/elementals";
import DescriptionValueWithIcon from "../../../PolicyCardOverlay/DescriptionValueWithIcon/DescriptionValueWithIcon";
import {CoinsStat} from "../../../PlayerStat/stats/CoinsStat";

const FactionElementalsDescription = () => {
  const elementEarth = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-left'}
    src={'/img/icons/element_earth.png'}
    alt={'Земля'}
    title={'Земля (для строительства Кварталов и Специальных строений)'}
  />;
  const elementFire = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-min'}
    src={'/img/icons/element_fire.png'}
    alt={'Огонь'}
    title={'Огонь (для строительства Казарм)'}
  />;
  const elementWheat = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left-min'}
    src={'/img/icons/element_wheat.png'}
    alt={'Зерно'}
    title={'Зерно (для строительства Ферм)'}
  />;

  const action = <img
    className={'policy-description-icon'}
    src={'/img/icons/action.png'}
    alt={'Действие'}
    title={'Действие в Фазе Строительства'}
  />;

  const actionMarginLeft = <img
    className={'policy-description-icon policy-description-icon-margin-left-end'}
    src={'/img/icons/action.png'}
    alt={'Действие'}
    title={'Действие в Фазе Строительства'}
  />;

  const actionsBonusValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left-end'}
    value={`+${FACTION_ELEMENTALS_CONSTRUCTION_ACTIONS_BONUS}`}
    icon={action}
  />

  const hammer = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/hammer brown.png'}
    alt={'Строительство'}
    title={'Строительство'}
  />;

  const centralQuarter = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/icons/central quarter.7dd51bfd.png'}
    alt={'Центральный квартал'}
    title={'Центральный квартал'}
  />;

  const discountElement = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/percent white.png'}
    alt={'Скидка'}
    title={'Скидка'}
  />;

  const centralQuarterDiscount = <CoinsStat
    text={FACTION_ELEMENTALS_BUILDING_CENTRAL_QUARTER_DISCOUNT}
    noShrinkOnMobile={true}
    isDarkColor={true}
    className={'policy-description-icon-margin-left-end'}
  />;

  return (
    <>
      <div className="policy-description_line">
        В
        <span className={'text-construction policy-description-icon-margin-left'}>
          фазе Строительства
        </span>
        {actionsBonusValueAndIcon}
        .
      </div>
      <div className="policy-description_line policy-description_line-margin-top-paragraph">
        Игрок получает случайные элементы
      </div>
      <div className="policy-description_line">
        {elementEarth}{elementFire}{elementWheat} по количеству {actionMarginLeft}.
      </div>
      <div className="policy-description_line policy-description_line-margin-top">
        При {hammer} игрок тратит элемент
      </div>
      <div className="policy-description_line">
        соответствующего цвета.
      </div>

      <div className="policy-description_line policy-description_line-margin-top-paragraph">
        {centralQuarter} дешевле {discountElement} на {centralQuarterDiscount}.
      </div>
    </>
  );
};

export default FactionElementalsDescription;
